import React, { useState } from 'react';

const SmartImage = ({ src, alt = '', className = '', size = 'medium', fallback = '📦' }) => {
  const [imageError, setImageError] = useState(false);

  // تحديد إذا كان emoji أو صورة
  const isEmoji = !src?.startsWith('http') && !src?.startsWith('data:image') && !src?.startsWith('blob:') && !src?.startsWith('/');

  // أحجام للـ emoji فقط
  const emojiSizes = {
    small: 'text-3xl',
    medium: 'text-5xl',
    large: 'text-6xl',
    xlarge: 'text-8xl'
  };

  // أحجام افتراضية للصور (تُستخدم فقط إذا لم يتم تمرير className مخصص)
  const defaultImageSizes = {
    small: 'w-12 h-12',
    medium: 'w-20 h-20',
    large: 'w-32 h-32',
    xlarge: 'w-48 h-48'
  };

  // إذا كان emoji أو لا يوجد src أو فشل تحميل الصورة
  if (isEmoji || !src || imageError) {
    return (
      <div className={`${emojiSizes[size]} ${className} flex items-center justify-center`}>
        {src || fallback}
      </div>
    );
  }

  // عرض صورة حقيقية
  // إذا تم تمرير className مخصص يحتوي على w- أو h-، استخدمه
  // وإلا استخدم الأحجام الافتراضية
  const hasCustomSize = className.includes('w-') || className.includes('h-');
  const imageClassName = hasCustomSize
    ? `object-cover rounded-lg ${className}`
    : `${defaultImageSizes[size]} object-cover rounded-lg ${className}`;

  return (
    <img
      src={src}
      alt={alt}
      className={imageClassName}
      onError={() => setImageError(true)}
      loading="lazy"
    />
  );
};

export default SmartImage;
